import { render, staticRenderFns } from "./PackageFeaturesForm.vue?vue&type=template&id=6e76c9a1&"
import script from "./PackageFeaturesForm.vue?vue&type=script&lang=js&"
export * from "./PackageFeaturesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports